



































import { defineComponent, PropType } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'JetSelect',
  props: {
    label: {
      type: String as PropType<string>,
      default: '',
    },
    value: {
      type: String as PropType<string>,
      default: '',
    },
    placeholder: {
      type: String as PropType<string>,
      default: '',
    },
    errorMessage: {
      type: String as PropType<string>,
      default: '',
    },
    required: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    disabled: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
  methods: {
    changeHandler(event: Event) {
      const target = event.target as HTMLSelectElement;
      this.$emit('input', target.value);
    },
  },
});
